import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-v', 'LetterV', [["path",{"d":"m8 7 3.75 10L15.5 7","key":"svg-0"}]]);